module.exports = __webpack_public_path__ + "static/img/block-bg3.8e35505a.png";